import { createFragment, debounce, delegatedEvent } from '../lib/lib';

const FILTER_FORM_ID = 'product-filter-form';
const getFilterFormElement = () => document.getElementById(FILTER_FORM_ID);
const getSearchTextInput = () =>
  document.querySelector('.c-filter__search-input');

const getSelectedFilters = () =>
  document.querySelectorAll('.c-filter__checkbox:checked');

const getActiveFilterContainer = () =>
  document.querySelector('.c-filter__active-filters');

const getClearAllFiltersButton = () =>
  document.querySelector('.c-filter__clear');

const getResultCounter = () => document.querySelector('.c-filter__status-hits');
const getResultSection = () => document.querySelector('.c-filter__results');

const createFilterButton = (text, id) =>
  `<button class="c-filter__input c-filter__active" data-filter-id="${id}">
       <span class="mr-1">${text}</span>
       <span class="c-filter__remove"></span>
   </button>`;

const renderFilterButtons = () => {
  const buttons = [...getSelectedFilters()].reduce((ret, input) => {
    const { id } = input;
    const text = document.querySelector(`[for=${id}]`).textContent;

    return ret + createFilterButton(text, id);
  }, '');

  const container = getActiveFilterContainer();
  container.querySelectorAll('.c-filter__active').forEach(child => {
    child.parentElement.removeChild(child);
  });

  const fragment = createFragment(buttons);
  container.prepend(fragment);
};

const generateUrl = (formData, base = location.pathname) => {
  const search = new URLSearchParams(formData);
  return `${base}?${search.toString()}`;
};

const onFormChange = () => {
  const resultSection = getResultSection();
  const formData = [...new FormData(getFilterFormElement())].filter(
    // filter out text if empty
    data => data[1] !== '',
  );

  // TODO: Do we need to handle popstate? as we're never navigating between states on this page...
  history.replaceState(formData, '', generateUrl(formData));
  renderFilterButtons();

  resultSection.classList.add('loading');
  fetch(generateUrl(formData, `${location.pathname}search/`))
    .then(response => {
      if (response.ok) return response.text();
      else throw new Error(response.statusText);
    })
    .then(text => {
      resultSection.innerHTML = text;
    })
    .catch(error => {
      // TODO: handle this?
      resultSection.innerHTML = 'Error loading data';
    })
    .finally(() => {
      resultSection.classList.remove('loading');
      getResultCounter().innerHTML = resultSection.children.length;
    });
};

const onFilterButton = (element, e) => {
  e.preventDefault();
  const filterCheckBox = document.getElementById(
    element.getAttribute('data-filter-id'),
  );
  if (filterCheckBox) {
    filterCheckBox.click();
  }
};

const clearForm = event => {
  event.preventDefault();
  getSelectedFilters().forEach(input => (input.checked = false));
  getSearchTextInput().value = '';
  onFormChange();
};

const addFilterEvents = () => {
  getFilterFormElement().addEventListener('change', onFormChange);
  getClearAllFiltersButton().addEventListener('click', clearForm);
  // eslint-disable-next-line no-magic-numbers
  getSearchTextInput().addEventListener('input', debounce(onFormChange, 300));
  delegatedEvent(getActiveFilterContainer())(
    'click',
    '.c-filter__active',
    onFilterButton,
  );
};

export const initProductListingFilter = () => {
  const filters = document.querySelector('#product-filter-form');
  if (!filters) {
    return;
  }

  addFilterEvents();
};
